window.addEventListener('load', function() {
  const arrowIcon = document.querySelector('.arrow-icon');
  const footer = document.getElementById('shopify-section-footer');

  // Scroll down by a specific amount when the arrow icon is clicked
  arrowIcon.addEventListener('click', function() {
    window.scrollBy({
      top: 700, // Adjust this value to control the scroll distance
      behavior: 'smooth'
    });
  });

  // Hide the arrow icon when the bottom of the page is in the viewport
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        arrowIcon.style.display = 'none';
      } else {
        arrowIcon.style.display = 'flex';
      }
    });
  }, { threshold: 0.5 });

  // Get all the elements with the class 'shopify-section' within the 'main' container
  const sections = document.querySelectorAll('main .shopify-section');

  // Observe the last 'shopify-section' element
  observer.observe(sections[sections.length - 1]);

});
